import { createContext, useState, useEffect, useRef, useCallback } from "react";
import { fetchAgents } from "../services/agentService";

export const AgentContext = createContext();

export default function AgentProvider({ children }) {
  const [agents, setAgents] = useState([]);
  const isFetching = useRef(false);   // guard: cegah concurrent fetch
  const abortRef   = useRef(null);    // simpan AbortController aktif

  const refreshAgents = useCallback(async () => {
    // Guard: skip jika sudah ada fetch yang sedang berjalan
    if (isFetching.current) return;

    const token = localStorage.getItem("token");
    if (!token) return;

    // Cancel request sebelumnya jika masih pending
    if (abortRef.current) {
      abortRef.current.abort();
    }
    abortRef.current = new AbortController();

    isFetching.current = true;
    try {
      const data = await fetchAgents(abortRef.current.signal);
      if (Array.isArray(data)) {
        setAgents(data);
      } else {
        setAgents([]);
      }
    } catch (error) {
      // Abaikan AbortError (bukan error sungguhan)
      if (error?.name !== "AbortError" && error?.code !== "ERR_CANCELED") {
        console.error("Gagal refresh agents:", error);
      }
    } finally {
      isFetching.current = false;
    }
  }, []);

  // Load awal — sekali saja
  useEffect(() => {
    refreshAgents();
    // Cleanup: cancel request jika component unmount
    return () => {
      if (abortRef.current) abortRef.current.abort();
    };
  }, [refreshAgents]);

  return (
    <AgentContext.Provider value={{ agents, refreshAgents }}>
      {children}
    </AgentContext.Provider>
  );
}